import React, { useEffect, useState } from 'react';
import { Card, CardBody, Container, Row, Col, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import BreadCrumb from '../Common/BreadCrumb';
import { MaterialReactTable } from 'material-react-table';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from '../Utils/Loader';
import { ToastContainer, toast } from 'react-toastify';
import { setEditSuccessMessage, setSuccessMessage } from '../../slices/toastMessage/action';
import { MenuItem } from "@mui/material";
import CommonModal from "../Utils/CommonModal";
import { fetchAllOffers } from '../../slices/offer/thunk';
import { handleExportData } from '../Utils/ExportToCsv';
import { PeerConfigurationForm } from './PeerConfigurationForm';
import { getAllPeerConfiguration } from '../../slices/PeerConfiguration/thunk';
import { getPeerConfiguration } from '../../slices/PeerConfiguration/GetPeerConfiguration/thunk';
import { deletePeerConfiguration } from '../../slices/PeerConfiguration/DeletePeerConfiguration/thunk';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { useColumnSettings } from '../Utils/useColumnSettings';
import CommonButton from '../Utils/CommonButton';
import { formatCellValue, formatDateForDisplay, hasPermission } from '../Utils/UtilityFunctions';

function Peerconfiguration() {
    const [loading, setLoading] = useState(false);
    const [messageForPopUp, setMessageForPopUp] = useState('');
    const [eventType, setEventType] = useState("")
    const [selectedQuota, setSelectedQuota] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [modal, setModal] = useState(false);
    const [modalForBulkDelete, setModalForBulkDelete] = useState(false)
    const [selectedRowsForBulkDelete, setSelectedRowsForBulkDelete] = useState()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const showSuccessMessage = useSelector((state) => state.SuccessToast.showSuccessMessage);
    const showEditSuccessMessage = useSelector((state) => state.SuccessToast.showEditSuccessMessage);
    const quotaByEventType = useSelector((state) => state.GetPeerConfiguration.GetPeerConfiguration);
    const rating = useSelector((state) => state.GetAllPeerConfiguration.peerConfiguration)
    const [modalOpen, setModalOpen] = useState(false);
    const [settingsOpen, setSettingsOpen] = useState(false)
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [viewPeerData, setViewPeerData] = useState(null);

    const CustomTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#e9ecef',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 300,
            maxHeight: 250,
            fontSize: theme.typography.pxToRem(14),
            border: '1px solid #dadde9',
            padding: '16px',
            borderRadius: '4px',
            overflowY: 'auto'
        },
    }));

    const tooltipModifiers = {
        modifiers: [
            {
                name: 'preventOverflow',
                options: {
                    boundary: 'window',
                    altAxis: true,
                    padding: 8
                },
            },
            {
                name: 'flip',
                options: {
                    fallbackPlacements: ['left', 'bottom', 'top'],
                },
            },
            {
                name: 'offset',
                options: {
                    offset: [0, 5],
                },
            },
        ],
    };

    const toggleModals = () => {
        setModalOpen(prev => !prev);
    };

    const toggleViewModal = () => {
        setViewModalOpen(prev => !prev);
    };

    const rawPermissions = useSelector(
        (state) => state.permissions.permissionsMap
    );

    const permissionsMap = new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );
    const peerconfigurationPermission = hasPermission(permissionsMap, "charging", "peerConfigurations")
    const viewPermission = hasPermission(permissionsMap, "miscellaneous", "view")
    const parseAlternativePeerNames = (alternativePeerNames) => {
        if (!alternativePeerNames) return [];
        if (Array.isArray(alternativePeerNames)) return alternativePeerNames;
        if (typeof alternativePeerNames === 'string') {
            return alternativePeerNames.split(',').map(name => name.trim()).filter(name => name);
        }
        return [];
    };

    const formatAlternativePeerNamesForTable = (alternativePeerNames) => {
        const namesArray = parseAlternativePeerNames(alternativePeerNames);
        if (namesArray.length === 0) return '';
        if (namesArray.length === 1) return namesArray[0];
        if (namesArray.length > 1) {
            return (
                <>
                    {namesArray[0]}{" "}
                    <span className="text-muted">&nbsp;+ {namesArray.length - 1} more</span>
                </>
            );
        }
        // return `${namesArray[0]}...`;
    };

    const getFullAlternativePeerList = (alternativePeerNames) => {
        const namesArray = parseAlternativePeerNames(alternativePeerNames);
        if (namesArray.length === 0) return 'No alternative names';
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                {namesArray.map((name, index) => (
                    <span key={index} style={{ padding: '4px 0', whiteSpace: 'nowrap' }}>{name}</span>
                ))}
            </div>
        );
    };

    const columns = [
        {
            accessorKey: 'peerName',
            header: 'Peer Name',
            Cell: ({ cell }) => formatCellValue(cell.getValue()),
        },
        {
            accessorKey: 'alternativePeerNames',
            header: 'Alternative Peer list',
            Cell: ({ row }) => {
                const alternativePeerNames = row.original.alternativePeerNames;
                if (!alternativePeerNames || alternativePeerNames.length === 0) {
                    return <span>-</span>;
                }
                const namesArray = parseAlternativePeerNames(alternativePeerNames);

                return (
                    <CustomTooltip
                        title={getFullAlternativePeerList(alternativePeerNames)}
                        placement="right"
                        PopperProps={tooltipModifiers}
                        disableInteractive={false}
                        enterDelay={100}
                        leaveDelay={100}
                    >
                        <span className="cursor-pointer">
                            {formatAlternativePeerNamesForTable(alternativePeerNames)}
                        </span>
                    </CustomTooltip>
                );
            }
        },
    ];

    useEffect(() => {
        dispatch(getAllPeerConfiguration(setLoading))
        dispatch(fetchAllOffers(setLoading));
    }, [dispatch]);

    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            .cursor-pointer {
                cursor: pointer;
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    useEffect(() => {
        if (isEditMode && quotaByEventType) {
            setSelectedQuota(prev => ({ ...prev, ...quotaByEventType }));
        }
    }, [quotaByEventType]);

    useEffect(() => {
        if (showSuccessMessage) {
            toast.success(`Peer Configuration Created Successfully`);
            dispatch(setSuccessMessage(false));
        }
        if (showEditSuccessMessage) {
            toast.success(`Peer Configuration Updated Successfully`);
            dispatch(setEditSuccessMessage(false));
        }
    }, [showSuccessMessage, showEditSuccessMessage, dispatch]);

    const toggleModal = (id, singleOrMulti) => {
        if (singleOrMulti === "single") {
            setEventType(id);
            setModal(!modal);
        }
        document.body.style.overflow = 'auto';
    };

    const {
        CustomViewModal,
        settingsModalOpen,
        viewColumns,
        toggleSettingsModal,
        SettingsSidebar
    } = useColumnSettings('peerConfiguration', columns);

    useEffect(() => {
        setSettingsOpen(settingsModalOpen)
    }, [settingsModalOpen])

    return (
        <React.Fragment>
            <div id='csms' className='page-content bg-white mb-0'>
                <Container fluid>
                    <BreadCrumb title="Peer Configurations" pageTitle="Charging" />
                    <ToastContainer position='top-center' />

                    <div className="d-flex flex-sm-row flex-column w-100 justify-content-between align-items-lg-center gap-2 mb-1 mt-0">
                        <div className="d-flex flex-row gap-2">
                            <h5 className="rv-page-title p-2">Peer Configurations List</h5>
                        </div>
                        <div className="d-flex align-items-center">
                            {peerconfigurationPermission && peerconfigurationPermission?.has("export") &&
                                <Button
                                    color="secondary"
                                    className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 me-2 w-md-auto text-nowrap"
                                    onClick={() => {
                                        handleExportData(rating)
                                    }}
                                >
                                    <i className="ri-download-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                    <span className="px-2 ps-3 ms-2 me-1">Export</span>
                                </Button>}
                            {peerconfigurationPermission && peerconfigurationPermission?.has("create") &&
                                <Button
                                    color="secondary"
                                    className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 me-2 w-md-auto text-nowrap"
                                    onClick={() => {
                                        setModalOpen(true);
                                        setIsEditMode(false);
                                    }}
                                >
                                    <i className="ri-add-fill label-icon align-middle fs-16 me-1"></i>
                                    <span className="ps-2 ms-2 me-1">Add Peer</span>
                                </Button>}
                            {viewPermission && viewPermission?.has("view") &&
                                <i className="ri-settings-2-line fs-4" onClick={toggleSettingsModal}></i>}
                        </div>
                        {CustomViewModal()}
                    </div>
                    <Row className="d-flex align-items-sm-start">
                        <Col lg={12}>
                            <div className="container-fluid px-0">
                                <div className="disable-margin-card table-responsive table-customer border w-100">
                                    {loading && (<Loader />)}
                                    {quotaByEventType ?
                                        <>
                                            <MaterialReactTable
                                                enableTopToolbar={false}
                                                icons={{
                                                    DragHandleIcon: () => <i className="ri-drag-move-fill" />,
                                                }}
                                                positionToolbarAlertBanner='none'
                                                initialState={{
                                                    columnOrder: [
                                                        'mrt-row-actions',
                                                        'Name',
                                                        'Value Type'
                                                    ]
                                                }}
                                                columns={columns.filter((column) => viewColumns?.includes(column.accessorKey || column.header))}
                                                data={rating}
                                                enableSorting={true}
                                                enableColumnDragging={false}
                                                enableRowActions={true}
                                                enableDensityToggle={false}
                                                enableColumnFilters={true}
                                                enableColumnActions={true}
                                                displayColumnDefOptions={{
                                                    'mrt-row-actions': {
                                                        header: '',
                                                        enableHiding: false,
                                                        size: 36,
                                                        grow: true,
                                                        muiTableBodyCellProps: {
                                                            sx: {
                                                                fontFamily: "Inter,sans-serif",
                                                                maxWidth: "60px"
                                                            }
                                                        },
                                                        muiTableHeadCellProps: {
                                                            sx: {
                                                                fontFamily: "Inter,sans-serif",
                                                                maxWidth: "60px"
                                                            }
                                                        }
                                                    },
                                                }}
                                                defaultColumn={{
                                                    // minSize: 1,
                                                    maxSize: 9001,
                                                    muiTableBodyCellProps: {
                                                        sx: {
                                                            fontFamily: "Inter,sans-serif"
                                                        }
                                                    },
                                                    muiTableHeadCellProps: {
                                                        sx: {
                                                            fontFamily: "Inter,sans-serif"
                                                        }
                                                    }
                                                }}
                                                layoutMode='grid'
                                                renderRowActionMenuItems={({ closeMenu, row }) => [
                                                    peerconfigurationPermission && peerconfigurationPermission?.has("view") ?
                                                        <MenuItem className='row-options pb-3' key={`${row.index}.1`} onClick={() => {
                                                            setViewPeerData(row.original);
                                                            setViewModalOpen(true);
                                                            closeMenu();
                                                        }}><i className="ri-eye-line me-2" /> View</MenuItem> : null,
                                                    peerconfigurationPermission && peerconfigurationPermission?.has("update") ?
                                                        <MenuItem className='row-options pb-3' key={`${row.index}.2`} onClick={() => {
                                                            setIsEditMode(true);
                                                            setSelectedQuota(row.original);
                                                            setModalOpen(true);
                                                            dispatch(getPeerConfiguration(setLoading, row.original.peerName));
                                                            closeMenu();
                                                        }}><i className="ri-edit-box-line me-2" /> Edit</MenuItem> : null,
                                                    peerconfigurationPermission && peerconfigurationPermission?.has("delete") ?
                                                        <MenuItem className='row-options pb-3'
                                                            key="delete"
                                                            onClick={() => {
                                                                setMessageForPopUp(`Are you sure you want to Delete this Peer Configuration "${row.original.peerName}"?`)
                                                                toggleModal(row, "single");
                                                                closeMenu();
                                                            }}
                                                        >
                                                            <i className="ri ri-delete-bin-5-line me-2" /> Delete
                                                        </MenuItem> : null,
                                                ]}
                                            />
                                        </>
                                        : null
                                    }
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <CommonModal modalHeader={'Delete Peer'} messageForPopUp={messageForPopUp} toggle={() => { if (modal) { toggleModal(eventType, "single") } else { toggleModal(selectedRowsForBulkDelete, "multi") } }
                } open={modalForBulkDelete ? modalForBulkDelete : modal} buttonText={"Yes, Delete It"} modalAction={() => {
                    if (modal) {
                        dispatch(deletePeerConfiguration(eventType.original.peerName, setLoading, navigate));
                        toggleModal(eventType, "single");
                    }
                }} />

                {/* Edit/Add Modal */}
                <Modal isOpen={modalOpen} toggle={toggleModals} centered className="rv-modal attribute-modal" size="md">
                    <ModalHeader className="d-flex align-items-center mb-0 pb-0">
                        {isEditMode ? "Edit Peer" : "Add Peer"}
                        <button type="button" className="close-button-currency mt-n1 fs-1" onClick={toggleModals}>
                            &times;
                        </button>
                    </ModalHeader>
                    <ModalBody className="modal-body mt-0 pt-0 d-block">
                        <PeerConfigurationForm toggleModals={toggleModals} setModalOpen={setModalOpen} initialData={isEditMode ? selectedQuota : null} isEditMode={isEditMode} rating={rating} />
                    </ModalBody>

                </Modal>

                {/* View Modal */}
                <Modal isOpen={viewModalOpen} toggle={toggleViewModal} centered size="md" className="rv-modal attribute-modal">
                    <ModalHeader className="d-flex align-items-center mb-0 pb-0">
                        View Peer
                        <button type="button" className="close-button-currency mt-n1 fs-1" onClick={toggleViewModal}>
                            &times;
                        </button>
                    </ModalHeader>
                    <ModalBody className="modal-body mt-0 pt-0 d-block">
                        {viewPeerData && (
                            <div className="view-peer-container">
                                <div className="mb-4">
                                    <h6 className="mb-2 text-black fw-bold">Peer Name</h6>
                                    <p className="mb-0 fs-6 fw-normal offer-name">{viewPeerData.peerName}</p>
                                </div>
                                <div className="mb-4 w-100">
                                    <h6 className="mb-2 text-black fw-bold">Alternative Peer List</h6>
                                    {parseAlternativePeerNames(viewPeerData.alternativePeerNames).length > 0 ? (
                                        <ul className="list-group fw-normal offer-name">
                                            {parseAlternativePeerNames(viewPeerData.alternativePeerNames).map((name, index) => (
                                                <li key={index} className="list-group-item border-0 ps-0 py-1">
                                                    {name}
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p className="mb-0 fs-6">No alternative names specified</p>
                                    )}
                                </div>
                                <div className="d-flex justify-content-center mt-4">
                                    <CommonButton
                                        color={"main-color"}
                                        className={
                                            "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap"
                                        }
                                        icon={
                                            <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-2"></i>
                                        }
                                        buttonAction={toggleViewModal}
                                        btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                                        type="submit"
                                        buttonText={"Okay"}
                                    />
                                </div>
                            </div>
                        )}
                    </ModalBody>
                </Modal>
            </div>
        </React.Fragment>
    );
}

export default Peerconfiguration;